import {FC, useState, useEffect, Fragment} from 'react'

import './style.css'
import HTMLRenderer from 'react-html-renderer'
import Api from '../../../thesis-and-dissertations/helpers/api'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError'
import {toast} from 'react-toastify'
import {useNavigate} from 'react-router-dom'
import AlertModal from './AlertModal'
import {OverlayTrigger, Tooltip, Modal} from 'react-bootstrap'
const api = new Api()

type Props = {
  dataPana: any
  handleToPage: any
}

const ProposalContent: FC<Props> = ({dataPana, handleToPage}) => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState({
    delete: false,
    resubmit: false,
  })
  const [asTeam, setAsTeam] = useState(false) // Default false untuk individu
  const [registrationClosed, setRegistrationClosed] = useState(false)
  const [showDeadlineModal, setShowDeadlineModal] = useState(false)
  const [themeData, setThemeData] = useState<any>(null)

  useEffect(() => {
    checkRegistrationDeadline()
  }, [])

  const checkRegistrationDeadline = () => {
    // Fetch theme list untuk mendapatkan tanggal_akhir
    api
      .getThemeList()
      .then((themeResponse: any) => {
        let themeList = []
        if (themeResponse.data?.data?.data) {
          themeList = themeResponse.data.data.data
        } else if (themeResponse.data?.data && Array.isArray(themeResponse.data.data)) {
          themeList = themeResponse.data.data
        } else if (Array.isArray(themeResponse.data)) {
          themeList = themeResponse.data
        }

        if (themeList.length > 0) {
          const theme = themeList[0]
          setThemeData(theme)

          // Fetch server time
          api
            .getTimeServer()
            .then((timeResponse: any) => {
              const serverTime = timeResponse.data?.server_time
              const endDate = theme.tanggal_akhir

              if (endDate && serverTime) {
                const now = new Date(serverTime)
                const deadline = new Date(endDate)
                const isClosed = now > deadline

                setRegistrationClosed(isClosed)

                // Tampilkan modal jika pendaftaran sudah ditutup
                if (isClosed) {
                  setShowDeadlineModal(true)
                }
              }
            })
            .catch((error: any) => {
              console.error('Error fetching server time:', error)
            })
        }
      })
      .catch((error: any) => {
        console.error('Error fetching theme list:', error)
      })
  }

  // useEffect(() => {
  //   // Hanya check teams kalau tipe kelompok
  //   if (dataPana?.tipe == 'kelompok') {
  //     checkTeams()
  //   } else {
  //     // Kalau individu, langsung set asTeam = false
  //     setAsTeam(false)
  //   }
  // }, [dataPana])

  // const checkTeams = () => {
  //   api
  //     .checkTeams()
  //     .then((response: any) => {})
  //     .catch((error: any) => {
  //       const {data, status} = error.response
  //       if (status == 400) {
  //         setAsTeam(false)
  //         return
  //       }
  //       handleApiError(error)
  //     })
  // }

  const handleShowModal = (type: string) => {
    setShowModal({
      delete: type == 'delete' ? true : false,
      resubmit: type == 'resubmit' ? true : false,
    })
  }

  const handleCloseAlertModal = () => {
    setShowModal({
      delete: false,
      resubmit: false,
    })
  }

  return (
    <>
      <Modal show={showDeadlineModal} centered size='sm' onHide={() => setShowDeadlineModal(false)}>
        <div className='p-10'>
          <div className='text-center mb-5'>
            <i className='bi bi-exclamation-triangle-fill text-warning' style={{fontSize: '4rem'}}></i>
          </div>
          <p className='h6 text-center mb-4'>Pendaftaran Telah Ditutup</p>
          <p className='text-center mb-0'>
            Periode pendaftaran telah berakhir. Anda tidak dapat lagi mengedit atau membatalkan pendaftaran.
          </p>
          <button
            type='button'
            className='btn btn-sm w-100 mt-8'
            style={{
              background: '#F95E2F',
              border: '1px solid #F95E2F',
              color: 'white'
            }}
            onClick={() => {
              setShowDeadlineModal(false)
              navigate('/my-pejuang')
            }}
          >
            Lihat Status Saya
          </button>
        </div>
      </Modal>

      <AlertModal
        showAlertModal={showModal?.delete}
        handleCloseAlertModal={handleCloseAlertModal}
        type='delete'
        title='Batalkan Pendaftaran'
        desc='Apakah Anda yakin ingin membatalkan pendaftaran? Tindakan ini akan menghapus semua data yang telah diisi.'
        handleToPage={handleToPage}
        dataPana={dataPana}
        buttonText='Ya, Batalkan'
      />

      <AlertModal
        showAlertModal={showModal?.resubmit}
        handleCloseAlertModal={handleCloseAlertModal}
        type='resubmit'
        title='Konfirmasi Pengiriman Ulang'
        desc='Apakah Anda yakin ingin mengirim ulang proposal? Data yang telah diisi tidak dapat diubah
          setelah pengiriman.'
        handleToPage={handleToPage}
        dataPana={dataPana}
        buttonText='Ya, Edit'
      />

      <p className='h6 mt-5'>Ringkasan Essay Prioritas 1</p>
      <div className='mt-5 mb-3'>
        <div className='p-5 border rounded-top' style={{backgroundColor: '#F4F7FE'}}>
          <p className='mb-0'>Tema Essay</p>
        </div>
        <div className='p-5 border rounded-bottom'>
          <p className='mb-0'>{dataPana?.judul_proposal || '-'}</p>
        </div>
        <div className='p-5 border rounded-top mt-4' style={{backgroundColor: '#F4F7FE'}}>
          <p className='mb-0'>Ringkasan</p>
        </div>
        <div className='p-5 border rounded-bottom ql-editor'>
          <HTMLRenderer html={dataPana?.ringkasan_proposal ?? ''} />
        </div>
      </div>

      {dataPana?.ringkasan_proposal_2 ? (
        <>
          <p className='h6 mt-15'>Ringkasan Essay Prioritas 2</p>
          <div className='mt-5 mb-10'>
            <div className='p-5 border rounded-top' style={{backgroundColor: '#F4F7FE'}}>
              <p className='mb-0'>Tema Essay</p>
            </div>
            <div className='p-5 border rounded-bottom'>
              <p className='mb-0'>{dataPana?.judul_proposal_2 || '-'}</p>
            </div>
            <div className='p-5 border rounded-top mt-4' style={{backgroundColor: '#F4F7FE'}}>
              <p className='mb-0'>Ringkasan</p>
            </div>
            <div className='p-5 border rounded-bottom ql-editor'>
              <HTMLRenderer html={dataPana?.ringkasan_proposal_2 ?? ''} />
            </div>
          </div>{' '}
        </>
      ) : null}

      {!asTeam ? (
        <div className='d-flex justify-content-end'>
          <OverlayTrigger
            placement='bottom'
            delay={{show: 250, hide: 400}}
            overlay={
              <Tooltip id='tooltip-bottom'>
                {registrationClosed
                  ? 'Periode pendaftaran telah berakhir'
                  : <>
                      Membatalkan pendaftaran akan menghapus seluruh data pengajuan Anda. Tindakan ini{' '}
                      <span className='fw-bold'>tidak dapat dibatalkan.</span>
                    </>
                }
              </Tooltip>
            }
          >
            <button
              className='btn btn-sm border text-primary border-primary mt-15'
              onClick={() => handleShowModal('delete')}
              disabled={loading || registrationClosed}
            >
              {loading ? 'Loading...' : 'Batalkan Pendaftaran'}
            </button>
          </OverlayTrigger>

          <OverlayTrigger
            placement='bottom'
            delay={{show: 250, hide: 400}}
            overlay={
              <Tooltip id='tooltip-bottom'>
                {registrationClosed
                  ? 'Periode pendaftaran telah berakhir'
                  : 'Gunakan tombol ini jika Anda ingin memperbarui atau mengedit data pengajuan Anda.'
                }
              </Tooltip>
            }
          >
            <button
              className='btn btn-sm btn-primary mt-15 mx-3'
              onClick={() => handleShowModal('resubmit')}
              disabled={loading || registrationClosed}
            >
              {loading ? 'Loading...' : 'Edit'}
            </button>
          </OverlayTrigger>
        </div>
      ) : null}
    </>
  )
}

const Proposal: FC<Props> = ({dataPana, handleToPage}) => {
  return <ProposalContent dataPana={dataPana} handleToPage={handleToPage} />
}

export default Proposal
